//分页参数
export const addition_20 = {"pageNo": 1, "pageSize":20}
export const addition_999 = {"pageNo": 1, "pageSize":999}
export const addition_10 = {"pageNo": 1, "pageSize":10}
export const addition_5= {"pageNo": 1, "pageSize":5}


export const version = '20200717'
export const APPLICATION_KEY = '6ee9d89011d5405a41292510afa3dc75'
export const APPLICATION_SECRET = '2fcce993447541fea5c41cc32886e4af'
export const CONTENT_TYPE = 'application/json'

// 日出
export const ENTERPRISE_KEY = '6ee9d89011d5405a41292510afa3dc75'
export const ENTERPRISE = '0000fe21aw'
export const ENTERPRISE_SIGNATURE = '2fcce993447541fea5c41cc32886e4af'

export const DOMAIN = 'api.zono.cn&80'
export const TEMP_UID = 'b7146ba22c711ba19397b7ffefb6a480'
export const TEMP_TOKEN = 'f82364d2fc236ce676a6da691506c884'
export const PRODUCT_KEYS = ['25101903150201000000190808un20gq']

export const PRODUCT_INFOS = {'0000fe21aw12138080002004086nkvyz':'ec0f5f61c738373e17d9d929d95d557b'}
// 短信签名,0为水滴物联，1为金云智控
export const sms_sign = 0

// 超级管理员
// export const SUPER_ADMIN = 0
// 超级管理员
export const ADMIN = 1
// 
export const FACTORY_USER = 2
// 经销商
export const DISTRIBUTER = 3
// 管理单位
// export const IN_CHARGE_USER = 4
// 监理单位
// export const MANAGER = 5
// 施工单位／工程商
export const INSTALL_UNIT  = 6
// 施工人员
// export const INSTALLER = 7
// 售后
export const AFTER_SALER = 8

// 普通用户
export const NORMAL = 999

//超级管理员
export const SUPERADMIN = "sis001"
// 企业管理员角色id
export const SuperAdmin_role = 'superAdmin'
// 纽恩泰工程商
export const engineer = 'engineer'
//售后
export const afterSales = 'afterSales'
// 普通用户
export const normalUser = 'normalUser'

//经销商
export const agentRole = 'distributor'

export const Saas_Version = '2.0.0.0_240717'

// 日出
export const SOCKET_HOST = 'wss://saas.solareastiot.com:447'
// export const SOCKET_HOST = 'wss://saas.solareastiot.com:8102'
export const DOWNLOAD_URL = 'https://saas.solareastiot.com/'
export const API_HOST = 'https://saas.solareastiot.com:80&8083'